import FixedPeriodTemplate from "./FixedPeriodTemplate.js";
import ModelFactory from "../../ModelFactory.js";
import RelativePeriodTemplate from "./RelativePeriodTemplate.js";

/**
 * TODO: write documentation
 */
class PeriodTemplateFactory extends ModelFactory {
	allClasses() {
		return [FixedPeriodTemplate, RelativePeriodTemplate];
	}

	_getTypeFromJson(json) {
		return json.periodTemplateType;
	}
}

const periodTemplateFactory = new PeriodTemplateFactory();

export default periodTemplateFactory;
